import { ElementRef } from '@angular/core';
import { UrlsService } from 'NewAngular/services/core/urls.service';
import { CookieService } from 'ngx-cookie-service';
import * as i0 from "@angular/core";
import * as i1 from "ngx-cookie-service";
import * as i2 from "NewAngular/services/core/urls.service";
import * as i3 from "../password-reveal/password-reveal.component";
import * as i4 from "@angular/forms";
export class PasswordResetComponent {
    constructor(cookieService, urlsService, el) {
        this.cookieService = cookieService;
        this.urlsService = urlsService;
        this.actionUrl = '';
        this.csrfToken = '';
        this.form = {
            newPassword1: '',
            newPassword2: '',
        };
        this.contactRedirectUrl = this.urlsService.SUPPORT.CONTACT_REDIRECT;
        this.form.newPassword1 = el.nativeElement.getAttribute('new_password1') || '';
        this.form.newPassword2 = el.nativeElement.getAttribute('new_password2') || '';
        this.actionUrl = el.nativeElement.getAttribute('actionUrl');
    }
    ngOnInit() {
        this.csrfToken = this.cookieService.get('csrftoken');
    }
}
PasswordResetComponent.ɵfac = function PasswordResetComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || PasswordResetComponent)(i0.ɵɵdirectiveInject(i1.CookieService), i0.ɵɵdirectiveInject(i2.UrlsService), i0.ɵɵdirectiveInject(i0.ElementRef)); };
PasswordResetComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PasswordResetComponent, selectors: [["ycn-password-reset"]], standalone: false, decls: 22, vars: 5, consts: [[1, "auth-form"], ["method", "post", "ngNoForm", "", 3, "action"], ["type", "hidden", "name", "csrfmiddlewaretoken", "autocomplete", "off", 3, "value"], [1, "form-row"], [1, "form-label", "form-label-thin"], [1, "field-input-group", "input-group", "field-input-group-password"], ["placeholder", "Password", "id", "id_password_1", "type", "password", "name", "new_password1", "maxlength", "50", "minlength", "8", "required", "", 1, "form-control", "field-input", 3, "ngModelChange", "ngModel"], ["passwordElementId", "id_password_1"], ["placeholder", "Password", "id", "id_password_2", "type", "password", "name", "new_password2", "maxlength", "50", "minlength", "8", "required", "", 1, "form-control", "field-input", 3, "ngModelChange", "ngModel"], ["passwordElementId", "id_password_2"], [1, "row", "form-group", "align-items-center"], [1, "col"], ["type", "submit", 1, "btn", "btn-primary"], [1, "col-auto", "text-right"], [1, "text-blue", 3, "href"]], template: function PasswordResetComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "form", 1);
        i0.ɵɵelement(2, "input", 2);
        i0.ɵɵelementStart(3, "div", 3)(4, "div", 4);
        i0.ɵɵtext(5, "New Password");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(6, "div", 5)(7, "input", 6);
        i0.ɵɵtwoWayListener("ngModelChange", function PasswordResetComponent_Template_input_ngModelChange_7_listener($event) { i0.ɵɵtwoWayBindingSet(ctx.form.newPassword1, $event) || (ctx.form.newPassword1 = $event); return $event; });
        i0.ɵɵelementEnd();
        i0.ɵɵelement(8, "ycn-password-reveal", 7);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(9, "div", 3)(10, "div", 4);
        i0.ɵɵtext(11, "Confirm New Password");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(12, "div", 5)(13, "input", 8);
        i0.ɵɵtwoWayListener("ngModelChange", function PasswordResetComponent_Template_input_ngModelChange_13_listener($event) { i0.ɵɵtwoWayBindingSet(ctx.form.newPassword2, $event) || (ctx.form.newPassword2 = $event); return $event; });
        i0.ɵɵelementEnd();
        i0.ɵɵelement(14, "ycn-password-reveal", 9);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(15, "div", 3)(16, "div", 10)(17, "div", 11);
        i0.ɵɵelement(18, "input", 12);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(19, "div", 13)(20, "a", 14);
        i0.ɵɵtext(21, " Contact support for assistance. ");
        i0.ɵɵelementEnd()()()()()();
    } if (rf & 2) {
        i0.ɵɵadvance();
        i0.ɵɵpropertyInterpolate("action", ctx.actionUrl, i0.ɵɵsanitizeUrl);
        i0.ɵɵadvance();
        i0.ɵɵpropertyInterpolate("value", ctx.csrfToken);
        i0.ɵɵadvance(5);
        i0.ɵɵtwoWayProperty("ngModel", ctx.form.newPassword1);
        i0.ɵɵadvance(6);
        i0.ɵɵtwoWayProperty("ngModel", ctx.form.newPassword2);
        i0.ɵɵadvance(7);
        i0.ɵɵproperty("href", ctx.contactRedirectUrl, i0.ɵɵsanitizeUrl);
    } }, dependencies: [i3.PasswordRevealComponent, i4.DefaultValueAccessor, i4.NgControlStatus, i4.RequiredValidator, i4.MinLengthValidator, i4.MaxLengthValidator, i4.NgModel], encapsulation: 2 });
